/** Clipboard gestures/reads are observations, not proof that the editor changed. */
export function clipboardOperationLabel(event) {
  if (event.operation !== 'paste') return event.operation || 'clipboard';
  if (event.outcome === 'unavailable') return 'clipboard read unavailable';
  if (event.outcome === 'read') return 'paste text read';
  if (event.outcome === 'requested') return 'paste requested';
  return 'paste'; // Historical monitored-command events keep their original label.
}

export function clipboardEvidenceNote(event) {
  if (event.outcome === 'unavailable') return 'The browser denied or could not read the clipboard. No pasted text was captured by this read.';
  if (event.outcome === 'requested') return 'A native paste gesture was observed. Check the adjacent document edits to confirm what was inserted.';
  if (event.outcome === 'read') return 'An explicit Paste command read this text. The read alone does not prove it was inserted; check the adjacent document edits.';
  return null;
}
